const reviewServiceMixin = {
    data: function () {
        return {
            REVIEW_BASE: '/Api/Review/'
        }
    },
    methods: { 
        getReviews: function (data) {
            return this.get(this.REVIEW_BASE, 'GetReviews', data);
        },
        addReview: function (data) {
            return this.post(this.REVIEW_BASE, 'AddReview', data, true);
        }
    }
}